module.exports = __webpack_public_path__ + "img/fengmian.b85481f5.jpg";